<template>
    <div class="ne-node-histogram-container nkn-explorer-card-shadow">
        <div class="ne-node-histogram"></div>
    </div>
</template>

<script>
  import echarts from "echarts"
  // let geoSummary = {}
  // function findFlagCode (countryName) {
  //   for (const key in geoSummary) {
  //     const element = geoSummary[key];
  //     if (element.Country === countryName) {
  //       return element.Cities[0].CountryCode
  //     }
  //   }
  // }
  let basedOption = {
    title: {
      show: false,
      // text: 'Nodes list',
      // textStyle: {
      //   fontFamily: '-apple-system, BlinkMacSystemFont, "Segoe UI", Roboto, "Helvetica Neue", Arial, sans-serif, "Apple Color Emoji", "Segoe UI Emoji", "Segoe UI Symbol"',
      // }
    },
    tooltip: {},
    grid: {
      left: 90,
      top: 60,
    },
    yAxis: {
      axisLine: {
        show: false,
      },
      axisTick: {
        show: false,
      },
      splitLine:{
        show:true,
        interval: 0,
      },
      axisLabel: {
        // formatter: function (value) {
        //         return `{value|${value}      }`
        // },
        //  rich: {
        //         value: {
        //           align: 'right',
        //           fontSize: 8,
        //             width: 12,
        //             height: 7,
        //             backgroundColor: {
        //               image: `/static/img/flags-normal/ad.png`
        //             }
        //         }
        //     },
        fontSize: 10,
        interval: 0,
        // showMinLabel: true,
        showMaxLabel: true,
        fontFamily: '-apple-system, BlinkMacSystemFont, "Segoe UI", Roboto, "Helvetica Neue", Arial, sans-serif, "Apple Color Emoji", "Segoe UI Emoji", "Segoe UI Symbol"',
      },
      data: []
    },
    xAxis: {
      show:true,
      axisLine: {
        show: false,
      },
      splitLine:{
        show:true
      }

    },
    series: [{
      name: 'Nodes count',
      type: 'bar',
      color: "#5693ed",
      data: [],
      barWidth: 8,
      barMinHeight: 1,
      label: {
        normal: {
          show: false,
          position: 'inside',
          textStyle: {
            fontSize: 12,
            color: '#ffffff',
            fontFamily: '-apple-system, BlinkMacSystemFont, "Segoe UI", Roboto, "Helvetica Neue", Arial, sans-serif, "Apple Color Emoji", "Segoe UI Emoji", "Segoe UI Symbol"',
          }
        }
      },
    }]
  }
  export default {
    name: "nkn-node-histogram",
    props: ["geoSummary"],
    data() {
      return {
        countries: [],
        count: [],
        chart: null
      }
    },
    methods: {
        updateChart() {
          let countries = []
          let count = []
          // geoSummary = this.geoSummary
          for(let i=0; i < this.geoSummary.length; i++) {
            if(this.geoSummary[i].Count < 1) {
              continue
            }
            if(this.geoSummary[i].Country.includes('Lithuania')) {
              this.geoSummary[i].Country = 'Lithuania'
            }
            countries.push(this.geoSummary[i].Country)
            count.push(this.geoSummary[i].Count)
          }

          if(countries.length > this.countries.length) {
            this.chart.dispose()

            $(this.$el).css({
              height: countries.length * 10
            })

            this.chart = echarts.init(this.$el);
            this.chart.setOption(basedOption);
          }

          this.countries = countries
          this.count = count

          basedOption.yAxis.data = this.countries

          basedOption.series[0].data = this.count

          this.chart.hideLoading()
          this.chart.setOption(basedOption)
        }
    },
    watch: {
      geoSummary() {
        this.updateChart()
      }
    },
    mounted() {
      this.chart = echarts.init(this.$el);
      this.chart.setOption(basedOption);
      this.chart.showLoading()
    }
  }
</script>

<style scoped>
    .ne-node-histogram-container {
        background-color: #ffffff;
        width: 100%;
        min-height: 500px;
        padding-left: 20px;
    }

    .ne-node-histogram {
        margin: 0 auto;
    }

    @media screen and (max-width: 768px) {
        .ne-node-histogram-container {
            padding: 0;
        }
    }
</style>


// WEBPACK FOOTER //
// src/components/home/plugins/nknNodeHistogram.vue